if (!customElements.get('card-carousel')) {
  class CardCarousel extends HTMLElement {
    #index = 0;
    #steering = false;
    #settle = null;

    connectedCallback() {
      this.row = this.querySelector('[data-carousel-row]');
      this.cards = Array.from(this.querySelectorAll('[data-carousel-card]'));
      this.current = this.querySelector('[data-carousel-current]');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.row || this.cards.length === 0) return;

      this.prev?.addEventListener('click', () => this.#go(this.#index - 1));
      this.next?.addEventListener('click', () => this.#go(this.#index + 1));
      this.row.addEventListener('scroll', this.#onScroll, { passive: true });
      this.resize = new ResizeObserver(() => {
        if (!this.#steering) this.#update();
      });
      this.resize.observe(this.row);

      this.#update();
    }

    disconnectedCallback() {
      this.row?.removeEventListener('scroll', this.#onScroll);
      this.resize?.disconnect();
      clearTimeout(this.#settle);
    }

    #go(target) {
      const count = this.cards.length;
      const index = ((target % count) + count) % count;
      const card = this.cards[index];
      if (!card) return;
      this.#index = index;
      if (this.current) this.current.textContent = String(index + 1);
      this.#steering = true;
      this.#holdUntilStill();
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.row.scrollTo({
        left: card.offsetLeft - this.cards[0].offsetLeft,
        behavior: reduced ? 'auto' : 'smooth',
      });
    }

    #holdUntilStill() {
      clearTimeout(this.#settle);
      this.#settle = setTimeout(() => {
        this.#steering = false;
        this.#update();
      }, 150);
    }

    #onScroll = () => {
      if (this.#steering) this.#holdUntilStill();
      else this.#update();
    };

    #update() {
      const left = this.row.scrollLeft;
      const scrollable = this.row.scrollWidth > this.row.clientWidth + 2;
      const atEnd = scrollable && left >= this.row.scrollWidth - this.row.clientWidth - 2;
      let index = this.cards.length - 1;

      if (!atEnd) {
        const origin = this.cards[0].offsetLeft;
        let best = Infinity;
        this.cards.forEach((card, i) => {
          const distance = Math.abs(card.offsetLeft - origin - left);
          if (distance < best) {
            best = distance;
            index = i;
          }
        });
      }

      this.#index = index;
      if (this.current && this.current.textContent !== String(index + 1)) {
        this.current.textContent = String(index + 1);
      }
    }
  }

  customElements.define('card-carousel', CardCarousel);
}
